import { PaletteOptions, ThemeOptions } from '@mui/material'
import { defaultTheme } from 'react-admin'
import { border } from './theme/border'
import { color, themeColor, xxllncColor } from './theme/color'
import { muiOverrides } from './theme/muiOverrides'
import { raOverrides } from './theme/raOverrides'
import { typography } from './theme/typography'
import type { Components, Theme } from '@mui/material'

export * from './theme/border'
export * from './theme/button'
export * from './theme/color'
export * from './theme/shadow'
export * from './theme/semanticTokens'
export * from './theme/typography'

interface ITheme extends ThemeOptions {
  palette?: PaletteOptions & {
    common: { [key: string]: string }
  }
  sidebar: {
    width: number;
    closedWidth: number;
  }
}

const components = {
  ...defaultTheme.components,
  ...raOverrides,
  ...muiOverrides,
} as Components<Omit<Theme, 'components'>>

// xxllnc.ai look: white header and sidebar, slate text, purple primary, DM Sans.
export const theme: ITheme = {
  ...defaultTheme,
  typography: {
    fontFamily: typography.body,
    h6: {
      color: themeColor.black,
      fontSize: 18,
      fontStyle: 'normal',
      fontWeight: 600,
      lineHeight: '24px',
      letterSpacing: '-0.01em',
    },
    subtitle1: {
      color: themeColor.slate80,
      fontSize: 14,
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: '20px',
    },
  },
  palette: {
    common: {
      black: themeColor.black,
      white: '#fff',
    },
    primary: color.primary,
    secondary: color.secondary,
    background: {
      default: '#fafafa',
    },
    text: {
      primary: themeColor.black,
    },
    error: {
      main: xxllncColor.red100,
    },
    mode: 'light',
  },
  sidebar: {
    width: 240,
    closedWidth: 64,
  },
  shape: {
    borderRadius: border.radius.md,
  },
  components,
}
